import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BoundingBox, IWaterSystemWCoordinates } from '../../../types';
import { createWaterSystemCoordinatesAsync, createWaterSystemCoordinatesAsyncBuilder } from './asyncRequest';

interface IWaterSystemCoordinatesData {
  invalidIdx : string[]
  boundingBox?: BoundingBox
  items : IWaterSystemWCoordinates[]
}

export interface WaterSystemCoordinatesInitialState {
  data: IWaterSystemCoordinatesData
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: WaterSystemCoordinatesInitialState = {
  data: {
    items: [],
    invalidIdx: []
  } as IWaterSystemCoordinatesData,
  loading: false,
  error: '',
  success: false,
};

export const WaterSystemCoordinatesSlice = createSlice({
    name: 'waterSystemCoordinatesSlice',
    initialState,
    reducers: {
      setWaterSystemCoordinates:(state, action: PayloadAction<IWaterSystemCoordinatesData>)=>{
        state.data = action.payload
      },
      resetWaterSystemCoordinates:(state)=>{
        state.data = initialState.data
      }
    },
    extraReducers: (builder) => {
        createWaterSystemCoordinatesAsyncBuilder(builder)
      },
    });
    
  export const WaterSystemCoordinatesActions = {
    ...WaterSystemCoordinatesSlice.actions,
    createWaterSystemCoordinatesAsync,
  };
  
  export const WaterSystemCoordinatesReducer = WaterSystemCoordinatesSlice.reducer;